import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import profits from '@gamiphy/loyalty-station-desktop/components/cashback/assets/profits.svg';
import { Trans } from '@gamiphy/react-i18n';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { observer } from 'mobx-react';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { formatDiscountValue } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';

const Congrats: React.FC = () => {
  if (!DiscountsStore.welcomeGiftDiscount) return null;

  return (
    <Box>
      <Box display="flex">
        <Box>
          <Typography fontSize={18} fontWeight={700}>
            <Trans
              i18nKey="coreloyalty.cashback.congrats"
              defaults="Congrats!"
            />
          </Typography>
          <Typography fontSize={14} fontWeight={400}>
            <Trans
              i18nKey="coreloyalty.cashback.firstOrder"
              defaults="Make your first order over {{minPurchase, currency}} and enjoy the {{discountValue}} discount you’ve unlocked."
              values={{
                minPurchase: DiscountsStore.welcomeGiftDiscount.cashbackConfig.minRedemptionValue,
                discountValue: formatDiscountValue(DiscountsStore.welcomeGiftDiscount),
              }}
            />
          </Typography>
        </Box>
        <Box component="img" src={ThemeStore.theme.popupsConfig?.welcomeGift?.image ?? profits} height={70} />
      </Box>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={() => UiStore.close()}
        sx={{ mt: 2, fontSize: 14 }}
      >
        <Trans
          i18nKey="coreloyalty.cashback.shopNow"
          defaults="Shop now"
        />
      </Button>
    </Box>
  );
};

export default observer(Congrats);
